module.exports = __webpack_public_path__ + "static/media/dev.ristolina.com.2bd709f6.png";